import { ObservationSchema } from '@ynomia/core/dist/blueprint';
import { ObservationAction } from '@ynomia/core/dist/telemetry';
import analytics from './Analytics';
import client from './Client';

export async function patchObservationDate(
  tenant: string,
  projectCode: string,
  observationID: string,
  date: Date,
) {
  analytics.trackEvent('Observation Edited');
  await client.server.patch(
    `/scratch/telemetry/observations/${tenant}/${projectCode}/${observationID}/date`,
    {
      date,
    },
  );
}

export async function deleteObservation(
  tenant: string,
  projectCode: string,
  observationID: string,
) {
  analytics.trackEvent('Observation Deleted');
  await client.server.delete(
    `/scratch/telemetry/observations/${tenant}/${projectCode}/${observationID}`,
  );
}

export async function fetchAutofillObservations(
  assetId: string | undefined,
  tenant: string,
  projectCode: string,
  observationBlueprintId: string,
) {
  const body: Record<string, any> = {
    limit: 1,
    observationBlueprintIds: [observationBlueprintId],
  };
  if (assetId) {
    body.forElementIds = [assetId];
  }
  const result = await client.server.post(
    `/scratch/telemetry/v2/${tenant}/${projectCode}/observations/find`,
    body,
  );
  return result.data;
}

export async function submitObservation(
  tenant: string,
  projectCode: string,
  observation: ObservationSchema,
  assetId: string,
  formData: { [key: string]: any },
) {
  const date = new Date();

  const action: ObservationAction = {
    action: 'OBSERVATION',
    date,
    tenant,
    project: projectCode,
    assetID: assetId,
    observation_id: observation.id,
    observation_data: formData,
  };

  const result = await client.server.post('/scratch/telemetry/action', action);
  return result.data;
}
